import React from 'react';
import { Box, Typography } from '@mui/material';
import FileManagement from '../../FileManagement';
import { DashboardData, DashboardFilters, FileFilters } from '../types/dashboard.types';
import { useTranslation } from '../../../i18n';

interface FilesTabProps {
  data: DashboardData;
  filters: DashboardFilters;
  onFilterChange: (filters: Partial<DashboardFilters>) => void;
  serialNumbers: string[];
  onResetFileFilters?: () => void;
}

export const FilesTab: React.FC<FilesTabProps> = ({
  filters,
  serialNumbers,
  onFilterChange,
  onResetFileFilters,
}) => {
  const { t } = useTranslation();

  const handleFileFilterChange = (fileFilterUpdates: Partial<FileFilters>) => {
    const newFilters = {
      ...filters.fileFilters,
      ...fileFilterUpdates,
    };
    onFilterChange({
      fileFilters: newFilters,
    });
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" gutterBottom>
          {t('fileManagement.title')}
        </Typography>
      </Box>

      {/* File Management Component */}
      <Box sx={{ flex: 1, minHeight: '600px' }}>
        <FileManagement
          fileFilters={filters.fileFilters}
          serialNumbers={serialNumbers}
          onFileFilterChange={handleFileFilterChange}
          onResetFileFilters={onResetFileFilters}
        />
      </Box>
    </Box>
  );
};
